String.prototype.escapeRegex =
  String.prototype.escapeRegex ||
  function () {
    'use strict';
    return this.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  };
